require('aframe');
require('../index.js');



//////////////////
// WEBPACK FOOTER
// ./components/barchart/examples/main.js
// module id = 8
// module chunks = 1